export const DAYS = 'days';
export const HOURS = 'hours';
export const MINUTES = 'minutes';
export const SECONDS = 'seconds';
export const PREFIX_WITHIN = 'within';
export const PREFIX_IN = 'in';
